<template>
  <div
    style="
      background-image: url('img/radio/room_bg.png');
      background-size: 100% 100%;
      height: calc(100vh - 120px);
      background-color: #431C68;
      background-repeat: no-repeat;
      overflow-y: scroll;
      padding-bottom: 120px;
    "
    @scroll="handleScroll"
  >
  <!-- <back-nav class="title_top" :icon="'img/backw.png'" :textColor="'#fff'" :backColor="'none'" /> -->
    <div
      class="roomNav"
    >
      <div
        class="room-title"
        v-for="(item, index) in ranklist"
        :key="index"
        :style="rankCur == index ? 'background-image:url(' + item.navAcBg + ')' : 'background-image:url(' + item.navBg + ')'"
        @click="rankchange(index, item.list_type)"
      >
      </div>
    </div>
    <div class="ranktype" v-if="this.rankCur !=2">
      <div
        class="romitem"
        :class="{ romName: ranklist[rankCur].cur == index }"
        v-for="(item, index) in ranklist[rankCur].type"
        :key="index"
        @click="typechange(index, item.sort_date)"
      >
        {{ item.name }}
      </div>
    </div>

    <div v-if="nodata" class="noData">
      <img :src="'img/noData.png'" alt="" />
    </div>
    <div class="list-scroll_" v-if="listItems.length > 0">
      <template>
        <div
          class="item_ display_flex justify-content_flex-justify align-items_center"
          v-for="(item, index) in listItems"
          :key="index"
          :style="index==0? 'background-image:url(' +'img/radio/item_bg_one.png'+ ')' : 'background-image:url(' + 'img/radio/item_bg.png' + ')'"
        >
          <div
            class="display_flex align-items_center"
            @click="checkUser(item.user_id)"
          >
           <div class="item-order_" v-if="index==0" style="background-image: url('img/radio/one.png');"></div>
           <div class="item-order_" v-if="index==1" style="background-image: url('img/radio/two.png');"></div>
           <div class="item-order_" v-if="index==2" style="background-image: url('img/radio/three.png');"></div>
            <div class="item-order_" v-if="index>2">{{ index + 1 }}</div>
            <div class="head_bg" v-if="index==0&&rankCur!=2" style="background-image: url('img/radio/head_bg_one.png');">
              <img class="item-img_" :src="item.head_portrait" alt="" />
            </div>
            <div class="head_bg" v-if="index==1&&rankCur!=2" style="background-image: url('img/radio/head_bg_two.png');">
              <img class="item-img_" :src="item.head_portrait" alt="" />
            </div>
            <div class="head_bg" v-if="index==2&&rankCur!=2" style="background-image: url('img/radio/head_bg_three.png');">
              <img class="item-img_" :src="item.head_portrait" alt="" />
            </div>
            <div class="head_bg" v-if="index>2&&rankCur!=2">
              <img class="item-img_" :src="item.head_portrait" alt="" />
            </div>

            <div class="head_big_bg" v-if="index==0&&rankCur==2">
              <div class="head_bg" style="background-image: url('img/radio/head_bg_one.png');">
                <img class="item-img_" :src="item.receive_head_portrait" alt="" />
              </div>
              <div class="head_bg_" style="background-image: url('img/radio/head_bg_one.png');">
                <img class="item-img_" :src="item.send_head_portrait" alt="" />
              </div>
            </div>
            <div class="head_big_bg" v-if="index==1&&rankCur==2">
              <div class="head_bg" style="background-image: url('img/radio/head_bg_two.png');">
                <img class="item-img_" :src="item.receive_head_portrait" alt="" />
              </div>
              <div class="head_bg_" style="background-image: url('img/radio/head_bg_two.png');">
                <img class="item-img_" :src="item.send_head_portrait" alt="" />
              </div>
            </div>
            <div class="head_big_bg" v-if="index==2&&rankCur==2">
              <div class="head_bg" style="background-image: url('img/radio/head_bg_three.png');">
                <img class="item-img_" :src="item.receive_head_portrait" alt="" />
              </div>
              <div class="head_bg_" style="background-image: url('img/radio/head_bg_three.png');">
                <img class="item-img_" :src="item.send_head_portrait" alt="" />
              </div>
            </div>
            <div class="head_big_bg" v-if="index>2&&rankCur==2">
              <div class="head_bg">
                <img class="item-img_" :src="item.receive_head_portrait" alt="" />
              </div>
              <div class="head_bg_">
                <img class="item-img_" :src="item.send_head_portrait" alt="" />
              </div>
            </div>
            <div class="display_flex align-items_center">
              <template v-if="rankCur!=2">
                <div class="item-name_">{{ item.nickname }}</div>
              </template>
              <template v-else>
                <div style="display: flex;flex-direction: column;">
                  <div class="item-name_">{{ item.receive_nickname }}</div>
                  <div class="item-name__"><span>打赏者:</span><span style="color: #FFA4EB;">{{ item.send_nickname }}</span></div>
                </div>
              </template>
            </div>
          </div>
          <div class="item-right" v-if="rankCur!=2">
            <div class="display_flex align-items_center">
              <span style="color: #FFE7CC; opacity: 0.7" v-if="rankCur == 0"
                >财富值</span
              >
              <span style="color:#FFE7CC; opacity: 0.7" v-if="rankCur == 1"
                >魅力值</span>
            </div>
            <template>
              <!-- <p v-if="rankCur == 3">{{ item.value }}</p> -->
              <p style="color: #FFE7CC">
                {{item.total_charm_value}}
              </p>
            </template>
          </div>
          <div class="item-right" style="display: flex;align-items: center;flex-direction: column;" v-else>
            <div style="display: flex;align-items: center;">
              <img class="gift_img" :src="item.gift_url" alt="">
              <span class="gift_num">{{'x'+item.num}}</span>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;">
                <!-- <span class="charm_value" style="color: #fff;">价值:</span> -->
                <img class="bi" src="img/bi.png" alt="">
                <span class="charm_value" style="color: #fff;">{{item.total_charm_value}}</span>
              </div>
            <div class="gift_time">{{item.created_at|getDateDiff}}</div>
          </div>
        </div>
      </template>
      <van-overlay :show="loading">
        <div style="display: flex;justify-content: center;align-items: center;width: 100%;height: 100%;">
          <van-loading/>
          <div style="color: #ffffff;">数据加载中...</div>
        </div>
        
      </van-overlay>
    </div>
  </div>
</template>

<script>
import "@/assets/css/rank.css";
import BackNav from "@/components/backNav.vue";
import {
  roomWealthList,
  roomCharismaList,
  surpriseList,
  loveList,
  luckyList,
} from "@/api/ranking";
export default {
  name: "room",
  components: {
    BackNav,
  },
  filters: {
    getDateDiff(date) {
   var dateTimeStamp = new Date(date).getTime()
	 var minute = 1000 * 60;
	 var hour = minute * 60;
	 var day = hour * 24;
	 var halfamonth = day * 15;
	 var month = day * 30;
	 var now = new Date().getTime();
	 var diffValue = now - dateTimeStamp;
	 if (diffValue < 0) {
		 	return;
	 }
		 var monthC = diffValue / month;
		 var weekC = diffValue / (7 * day);
		 var dayC = diffValue / day;
		 var hourC = diffValue / hour;
		 var minC = diffValue / minute;
		 var result 
		 if (monthC >= 1) {
			 result = "" + parseInt(monthC) + "月前";
		  } else if (weekC >= 1) {
			 result = "" + parseInt(weekC) + "周前";
		 } else if (dayC >= 1) {
		    result = "" + parseInt(dayC) + "天前";
		  } else if (hourC >= 1) {
			 result = "" + parseInt(hourC) + "小时前";
		 } else if (minC >= 1) {
		     result = "" + parseInt(minC) + "分钟前";
		 } else
	 result = "刚刚";
	 return result;
 }
  },
  data() {
    return {
      rankCur: 0,
      loading: false,
      page:1,
      ranklist: [
        {
          name: "财富榜",
          type: [
            {
              name: "日榜",
              sort_date: "day",
            },
            {
              name: "周榜",
              sort_date: "week",
            },
            {
              name: "月榜",
              sort_date: "month",
            },
            {
              name: "昨日",
              sort_date: "yesterday",
            }
          ],
          cur: 0,
          topbg: "img/radio/01.png",
          navBg:'img/radio/cf_default.png',
          navAcBg:'img/radio/cf_active.png'
        },
        {
          name: "魅力榜",
          type: [
            {
              name: "日榜",
              sort_date: "day",
            },
            {
              name: "周榜",
              sort_date: "week",
            },
            {
              name: "月榜",
              sort_date: "month",
            },
            {
              name: "昨日",
              sort_date: "yesterday",
            }
          ],
          cur: 0,
          topbg: "img/radio/02.png",
          navBg:'img/radio/ml_default.png',
          navAcBg:'img/radio/ml_active.png'
        },
        {
          name: "真爱榜",
          type: [
            {
              name: "日榜",
              sort_date: "day",
            },
            // {
            //   name: "周榜",
            //   sort_date: "week",
            // },
            // {
            //   name: "月榜",
            //   sort_date: "month",
            // },
            // {
            //   name: "昨日",
            //   sort_date: "yesterday",
            // }
          ],
          cur: 0,
          topbg: "img/radio/03.png",
          navBg:'img/radio/za_default.png',
          navAcBg:'img/radio/za_active.png'
        }
      ],
      sort_date: "day",
      topThreeItems: [],
      listItems: [],
      nodata: false,
      // is_admin: false,
    };
  },
  created() {
    let access_token = this.$route.query.access_token;
    localStorage.setItem("access_token", access_token);
    this.getData();
  },
  methods: {
    //榜单切换
    rankchange(e, type) {
      this.rankCur = e;
      this.sort_date = "day";
      this.page=1;
      this.listItems = []
      this.ranklist[e].cur = 0;
      this.getData();
    },
    handleScroll(e) {
        const container = e.target;
        if(this.rankCur==2){
          if (
          container.scrollHeight - container.scrollTop <=
          container.clientHeight
        ) {
          this.page = this.page + 1;
          this.getData();
        }
        }
      },
    //周榜总榜切换455
    typechange(e, type) {
      let rankCur = this.rankCur;
      this.ranklist[rankCur].cur = e;
      this.sort_date = type;
      this.getData();
    },
    getData() {
      let Params = {
        room_id: this.$route.query.room_id,
        date_type: this.sort_date,
      };
      this.topThreeItems = []
      // this.listItems = []
      this.loading = true;
      if (this.rankCur == 0) {
        roomWealthList(Params)
          .then(
            (response) => {
              this.loading = false;    
              this.listItems = response.data.list 
              // this.is_admin = response.data.is_admin;
              if (response.data.list.length == 0) {
                this.nodata = true;
              } else {
                this.nodata = false;
              }
            },
            (error) => {
              this.$toast(error);
            }
          )
          .catch((error) => {
            this.$toast(error);
          });
      }
      if (this.rankCur == 1) {
        roomCharismaList(Params)
          .then(
            (response) => {
              this.loading = false;
              this.listItems =  response.data.list
              // this.is_admin = response.data.is_admin;
              if (response.data.list.length == 0) {
                this.nodata = true;
              } else {
                this.nodata = false;
              }
            },
            (error) => {
              this.$toast(error);
            }
          )
          .catch((error) => {
            this.$toast(error);
          });
      }
      if (this.rankCur == 2) {
        // surpriseList(Params)
        let params = {
          page:this.page,
          rows:15,
          date_type:'week',
          room_id:this.$route.query.room_id
        }
        loveList(params)
          .then(
            (response) => {
              this.loading = false;
              // this.is_admin = response.data.is_admin;
              if (this.page==1&&response.data.list.length == 0) {
                this.nodata = true;
              }else{
                this.listItems = this.listItems.concat(response.data.list)
                this.nodata = false;
              }
               
            },
            (error) => {
              this.$toast(error);
            }
          )
          .catch((error) => {
            this.$toast(error);
          });
      }
      if (this.rankCur == 3) {
        luckyList(Params)
          .then(
            (response) => {
              this.loading = false;
               this.listItems = response.data.list
              // this.is_admin = response.data.is_admin;
              if (response.data.list.length == 0) {
                this.nodata = true;
              } else {
                this.nodata = false;
              }
            },
            (error) => {
              this.$toast(error);
            }
          )
          .catch((error) => {
            this.$toast(error);
          });
      }
    },
    closePage() {
      let params = "调用";
      this.$bridge.callhandler("closePage", params, (data) => {
        // 处理返回数据
      });
    },
    checkUser(id) {
      let param = id.toString();
      this.$bridge.callhandler("checkUser", param, (data) => {
        // 处理返回数据
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->